module.exports = __webpack_public_path__ + "img/image_icon.56443481.svg";